var React = require('react');

function Yonilingam (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M21.337,30.012L23,35H9l1.663-4.988 M21,19\n\tc0,0,0-8.239,0-11s-2.239-5-5-5s-5,2.239-5,5s0,11,0,11 M38,19H1.408C2.749,25.839,8.769,31,16,31c3.616,0,6.929-1.29,9.506-3.436\n\tC28.082,25.42,31,23,34,23c1,0,4,0,4,0s-2,0-3,0"}));
}

Yonilingam.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = Yonilingam;

Yonilingam.default = Yonilingam;
